import { createSelector } from '@ngrx/store';

import { wizzardState } from '../root';

export const getWizzard = createSelector(wizzardState, (wizzard) => wizzard);
